import { Box } from "@mui/material";

const styles = {
    root: {
        px: {
            xs: 0,
            md: '6.5rem'
        },
        '&:not(:first-of-type)': {
            pt: '3.75rem'
        },

        '&:not(:last-child)': {
            pb: '3.75rem'
        }
    }
};

export const StyledSection = ({ children, sx }) => {

    const section_styles = { ...styles.root, ...sx };

    return (
        <Box component={'section'} sx={section_styles}>
            {children}
        </Box>
    );
};